<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card light>
        <v-card-title class="headline">Subsanación</v-card-title>
        <v-card-actions>
          <v-flex xs5 ml-3>Cantidad de días:</v-flex>
          <v-spacer></v-spacer>
          <v-flex xs3 pt-3 mr-5>
            <v-text-field v-model="days" mask="###" light solo @input="$v.days.$touch()"></v-text-field>
          </v-flex>
        </v-card-actions>
        <v-card-text class="red--text pl-4" v-for="error in daysErrors" :key="error">Error: {{ error }}</v-card-text>
        <v-card-actions>
          <v-btn color="error" flat @click="dialog = false">Volver</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="submit">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ConfirmationDialog ref="confirm" :function-yes="bindingFunction"></ConfirmationDialog>
  </v-layout>
</template>

<script>
import ConfirmationDialog from '../../../common/ui/ConfirmationDialog'
import { validationMixin } from 'vuelidate'
import { required, between } from 'vuelidate/lib/validators'

export default {
  components: {
    ConfirmationDialog
  },

  mixins: [validationMixin],

  validations: {
    days: {
      required,
      between: between(1, 365)
    }
  },

  data () {
    return {
      dialog: false,
      days: 1,
      bindingFunction: null
    }
  },

  computed: {
    daysErrors () {
      const errors = []
      if (!this.$v.days.$dirty) return errors
      !this.$v.days.required && errors.push('campo requerido')
      !this.$v.days.between && errors.push('rango permitido 1-365 días')
      return errors
    }
  },

  methods: {
    openDialog () {
      this.dialog = true
    },
    submit () {
      if (!this.$v.$invalid) {
        this.$refs.confirm.openDialog()
        this.dialog = false
      }
    }
  },

  created () {
    this.bindingFunction = () => {
      const payload = {
        days: this.days
      }
      this.axios
        .put(`/presentaciones/subsanar/${this.$route.params.id}`, payload)
        .then(() => this.$router.push({ name: 'presentaciones' }))
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    }
  }
}
</script>
